import React from "react";
import { useNavigate } from "react-router-dom";
import spIcon from "../../assets/brand/swlogo.png";
import spWordmark from "../../assets/brand/swletters.png";

export const DocumentVerification = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] [font-family:'Nunito',Helvetica] text-[#5d4037]">

        {/* Centered Logo */}
        <div className="w-full flex justify-center">
          <div className="inline-flex items-center gap-[0px] leading-none">
            <img
              src={spIcon}
              alt="Sweet Plate logo"
              className="shrink-0 select-none object-contain w-[65px] h-[86px] -mt-[2px]"
            />
            <img
              src={spWordmark}
              alt="Sweet Plate"
              className="shrink-0 select-none object-contain h-[29px] w-auto -ml-[4px]"
            />
          </div>
        </div>

        {/* Title */}
        <h1 className="mt-3 ml-6 font-bold text-[22px] leading-7">Join Sweet Plate Vendor</h1>

        {/* Stepper  */}
        <div className="w-[378px] mx-auto mt-3 flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-[#5d4037] text-[#fff8e1] grid place-items-center text-sm font-bold">1</div>
          <div className="flex-1 h-[2px] bg-[#5d4037]/40" />
          <div className="w-8 h-8 rounded-full bg-[#5d4037] text-[#fff8e1] grid place-items-center text-sm font-bold">2</div>
        </div>

        <div className="w-[378px] mx-auto mt-6">
          <p className="font-extrabold uppercase text-[14px] tracking-wide">Document Verification</p>
          <p className="mt-1 text-[14px]">To complete your vendor verification, please upload</p>
        </div>

        {/* Cards */}
        <div className="w-[378px] mx-auto mt-4 space-y-5">

          {/* Business License */}
          <button
            type="button"
            onClick={() => navigate("/verify/business-license")}
            className="w-full rounded-[12px] border border-[#5d4037] bg-[#fff8e1] p-4 text-left hover:opacity-90 transition-opacity"
          >
            <div className="flex items-start gap-3">
              <div className="mt-0.5">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="#5d4037">
                  <path d="M12 2l3 5 6 .9-4.3 4.2 1 6-5.7-3-5.7 3 1-6L3 7.9 9 7l3-5z"/>
                </svg>
              </div>
              <div>
                <div className="font-bold">Business License</div>
                <div className="text-[13px] text-[#5d4037]/80">Click to upload</div>
              </div>
            </div>
          </button>

          {/* Address Proof */}
          <button
            type="button"
            onClick={() => navigate("/verify/address-proof")}
            className="w-full rounded-[12px] border border-[#5d4037] bg-[#fff8e1] p-4 text-left hover:opacity-90 transition-opacity"
          >
            <div className="flex items-start gap-3">
              <div className="mt-0.5">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#5d4037">
                  <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                </svg>
              </div>
              <div>
                <div className="font-bold">Address Proof</div>
                <div className="text-[13px] text-[#5d4037]/80">Click to upload</div>
              </div>
            </div>
          </button>

          {/* Profile Info (Phone Number) */}
          {/* <button
            type="button"
            onClick={() => navigate("/verify/update-profile")}
            className="w-full rounded-[12px] border border-[#5d4037] bg-[#fff8e1] p-4 text-left hover:opacity-90 transition-opacity"
          >
            <div className="flex items-start gap-3">
              <div className="mt-0.5">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="#5d4037">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1v3.19a1 1 0 01-.91 1A19 19 0 013 5.91 1 1 0 014 5h3.2a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.25 1.01l-2.9 2.2z"/>
                </svg>
              </div>
              <div>
                <div className="font-bold">Phone Number</div>
                <div className="text-[13px] text-[#5d4037]/80">Add / update phone number</div>
              </div>
            </div>
          </button> */}

        </div>

        {/* Next Button */}
        <div className="w-[378px] mx-auto">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="mt-8 w-[290px] h-[60px] mx-auto block rounded-[50px] bg-[#f7c945] font-bold text-[#5d4037] hover:opacity-90 transition-opacity"
          >
            Skip for Now
          </button>
        </div>
      </div>
    </div>
  );
};
